<template>
  <section class="turntable-main">
    <div class="turntable-inner">
      <div class="turntable-select"></div>
      <div class="turntable-item">
        <Turntable id="turnt" class="turntable-container"></Turntable>
      </div>
    </div>
    <ff-button type="spin" class="turntable-spin-btn" :class="spinStatus ? 'dark' : ''" @btnEvent="handleSpin">
      <span class="turntable-spin-text">
        {{$bus.finish === 1 ? $bus.transify['LUCKY_DRAW_OVER'] : $bus.transify['LUCKY_FREE_DRAW']}}
      </span>
    </ff-button>
    <p class="spin-tip bebas-font">{{$bus.transify['LUCKY_EVENT_REMINDER']}}</p>
  </section>
</template>

<script>
import ffButton from '@/components/common/Button.vue'
import Turntable from '@/components/main/turntable.vue'
export default {
  components: {
    ffButton,
    Turntable
  },
  computed: {
    spinStatus () {
      if (this.$bus.finish === 1) {
        return true
      }
      return this.$bus.enable !== -1 && !this.$bus.animating
    }
  },
  methods: {
    handleSpin () {
      if (this.$bus.animating) {
        return
      }
      if (this.$bus.finish === 1) {
        return
      }
      // 抽中但是未使用
      if (this.$bus.enable !== -1) {
        this.$bus.handleToast(true, 'LUCKY_SPIN_REMINDER')
        return
      }
      this.$api.draw({cost: 0}).then(res => {
        this.$bus.drawSound = true
        const pk = res.data.pk
        this.$bus.animating = true
        const index = this.$bus.discountPool.findIndex(item => item.pk === pk)
        if (this.$bus.deltaAngle === 67) {
          this.$bus.deltaAngle -= 22
        }
        this.$bus.deltaAngle += 360 * 4 + 360 - (index - this.$bus.prevRotateIndex) * 45
        this.$bus.prevRotateIndex = index
        this.$bus.enable = pk
      }).catch(err => { // TODO error rotate 30deg
        if (err) {
          // 网络中断情况
          this.$bus.deltaAngle = 67
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.turntable-main {
  @include px2res(width, 498);
  @include px2res(margin, 90, 30, 0, 0);
}
.turntable-inner {
  @include px2res(width, 498);
  @include px2res(height, 486);
  position: relative;
}
.turntable-select {
  @include px2res(width, 326);
  @include px2res(height, 320);
  position: absolute;
  left: 50%;
  top: -8.5%;
  z-index: 9;
  transform: translateX(-50%);
}
.turntable-spin-btn {
  @include px2res(margin-top, 8);
  margin: 0 auto;
}
.turntable-spin-text {
  color: #603B00;
  @include px2res(font-size, 38);
  background:linear-gradient(0deg,rgba(165,82,0,1) 0%,  rgba(68,48,0,1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.spin-tip {
  color: #fff;
  max-width: 80%;
  margin: 0 auto;
  text-align: center;
  @include px2res(font-size, 24);
}
.turntable-item {
  @include px2res(width, 392);
  @include px2res(height, 392);
  position: absolute;
  left: 50.5%;
  top: 49.8%;
  transform: translate(-50%, -50%);
}
/* .turntable-container {
  transform: rotate(45deg);
} */
</style>



// WEBPACK FOOTER //
// src/components/main/index.vue